"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _AbstractDeviceFrame = _interopRequireDefault(require("./AbstractDeviceFrame"));

var _colors = require("HubStyleTokens/colors");

// Reduce by 115
var MobilePortraitFrame = function MobilePortraitFrame(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("path", {
    d: "M1 30.503v469.994C1 516.79 14.211 530 30.507 530h237.986C284.791 530 298 516.792 298 500.497V30.503C298 14.21 284.789 1 268.493 1H30.507C14.209 1 1 14.208 1 30.503zM286.5 37.5v455.503c0 14.082-11.414 25.497-25.496 25.497H37.996c-14.081 0-25.496-11.415-25.496-25.497V37.5h274z",
    stroke: _colors.BATTLESHIP,
    fill: _colors.GYPSUM
  }), _react.default.createElement("g", {
    transform: "translate(120.5 20.5)"
  }, _react.default.createElement("path", {
    d: "M14.716 2.464h42.638",
    stroke: _colors.BATTLESHIP,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), _react.default.createElement("ellipse", {
    fill: _colors.BATTLESHIP,
    cx: "3.403",
    cy: "2.61",
    rx: "2.597",
    ry: "2.61"
  }))));
};

var MobileLandscapeFrame = function MobileLandscapeFrame(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("path", {
    d: "M30.503 298h469.994C516.79 298 530 284.789 530 268.493V30.507C530 14.209 516.792 1 500.497 1H30.503C14.21 1 1 14.211 1 30.507v237.986C1 284.791 14.208 298 30.503 298zM37.5 12.5h455.503c14.082 0 25.497 11.414 25.497 25.496v223.008c0 14.081-11.415 25.496-25.497 25.496H37.5v-274z",
    stroke: _colors.BATTLESHIP,
    fill: _colors.GYPSUM
  }), _react.default.createElement("g", {
    transform: "rotate(-90 99.5 79)"
  }, _react.default.createElement("path", {
    d: "M14.716 2.464h42.638",
    stroke: _colors.BATTLESHIP,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), _react.default.createElement("ellipse", {
    fill: _colors.BATTLESHIP,
    cx: "3.403",
    cy: "2.61",
    rx: "2.597",
    ry: "2.61"
  }))));
};

var MOBILE_DEVICE_SPECS = {
  mobilePortrait: {
    Template: MobilePortraitFrame,
    top: 37.5,
    right: 12.5,
    bottom: 12.5,
    left: 12.5,
    height: 531,
    width: 299
  },
  mobileLandscape: {
    Template: MobileLandscapeFrame,
    top: 12.5,
    right: 12.5,
    bottom: 12.5,
    left: 37.5,
    height: 299,
    width: 531
  }
};

var UIDeviceFrameMobile = function UIDeviceFrameMobile(props) {
  var children = props.children,
      className = props.className,
      contentClassName = props.contentClassName,
      orientation = props.orientation,
      rest = (0, _objectWithoutProperties2.default)(props, ["children", "className", "contentClassName", "orientation"]);
  var computedSpecs = orientation === 'landscape' ? MOBILE_DEVICE_SPECS.mobileLandscape : MOBILE_DEVICE_SPECS.mobilePortrait;
  return _react.default.createElement(_AbstractDeviceFrame.default, (0, _extends2.default)({}, rest, {
    className: className,
    contentClassName: contentClassName,
    spec: computedSpecs,
    orientation: orientation
  }), children);
};

UIDeviceFrameMobile.propTypes = {
  children: _react.PropTypes.node.isRequired,
  contentClassName: _react.PropTypes.string,
  orientation: _react.PropTypes.oneOf(['portrait', 'landscape'])
};
UIDeviceFrameMobile.defaultProps = {
  orientation: 'portrait'
};
UIDeviceFrameMobile.displayName = 'UIDeviceFrameMobile';
var _default = UIDeviceFrameMobile;
exports.default = _default;
module.exports = exports.default;